import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  NumberInput,
  NumberInputField,
  Textarea,
  Button,
  SimpleGrid,
  Heading,
  useToast,
  Checkbox,
  Spinner,
} from '@chakra-ui/react';
import axios from 'axios';
import HistoricoAvaluo from './historicoavaluo';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { getCookie } from 'cookies-next';
import { useJwt } from 'react-jwt';
import BloqueoPantalla from 'views/utils/BloqueoPantalla';

interface ZonaValor {
  id: number;
  descripcion: string;
  idTipoPredio: string;
  idClaveUso: string | null;
  habilitado: boolean;
}

interface NaturalezaActo {
  id: number;
  descripcion: string;
  habilitado: boolean;
}

interface Avaluo {
  id?: string;
  idMotivoAvaluo: number;
  idNaturalezaActo: number;
  fechaRegistro: string;
  fechaVencimiento: string;
  naturalezaActo: string;
  motivoAvaluo: string;
  cajaPagoPredial: string;
  folioPagoPredial: number;
  cajaPagoAvaluo: string;
  folioPagoAvaluo: number;
  obsAvaluo: string;
  valorCatastralTerreno: number;
  valorCatastralConstruccion: number;
  valorComercialTerreno: number;
  valorComercialConstruccion: number;
  valorComercial: number;
  valorTerreno: number;
  fechaActualizacion: string;
  fechaAvaluo: string;
}

interface UsoSuelo {
  id: number;
  descripcion: string;
  habilitado: boolean;
}

interface DetalleAvaluo {
  idZona: number;
  areaTerreno: number;
  factorTopografia: number;
  factorUbicacion: number;
  factorSuperficie: number;
  factorDistanciaU: number;
  factorFrente: number;
  factorProfundidad: number;
  distanciaU: number;

  areaTerrenoCarto: number;
  usoSuelo: string;
  medidaFrente: number;
  medidaFondo: number;
  ubicacion: string;
  tipoTopografia: string;
  desnivelPromedio: string;
  noEsquinas: number;
  dcurbano: string;
  factorResultante: number;
  zonaValor: string;
  valorM2: number;
  esValorProvisional: boolean;
}

interface MotivoAvaluo {
  id: number;
  descripcion: string;
  habilitado: boolean;
}

const AvaluoForm: React.FC<{ id: string }> = ({ id }) => {
  const [naturalezasActo, setNaturalezasActo] = useState<NaturalezaActo[]>([]); // Estado para almacenar naturalezas de acto
  const [motivosAvaluo, setMotivosAvaluo] = useState<MotivoAvaluo[]>([]);
  const toast = useToast();
  const [actualizacion, setActualizacion] = useState(0); // Contador para forzar la actualización del useEffect.

  const [avaluo, setAvaluo] = useState<Avaluo>({
    fechaRegistro: '',
    idMotivoAvaluo: 0,
    idNaturalezaActo: 0,
    fechaActualizacion: '',
    fechaAvaluo: '',
    valorTerreno: 0,
    fechaVencimiento: '',
    naturalezaActo: '',
    motivoAvaluo: '',
    cajaPagoPredial: '',
    folioPagoPredial: 0,
    cajaPagoAvaluo: '',
    folioPagoAvaluo: 0,
    obsAvaluo: '',
    valorCatastralTerreno: 0,
    valorCatastralConstruccion: 0,
    valorComercialTerreno: 0,
    valorComercialConstruccion: 0,
    valorComercial: 0,
  });
  const [loading, setLoading] = useState(false); // Estado para bloquear pantalla
  const [bandera, setBandera] = useState(false); // Estado para bloquear pantalla

  const [zonas, setZonas] = useState<ZonaValor[]>([]); // Estado para almacenar las zonas de valor
  const [usosSuelo, setUsosSuelo] = useState<UsoSuelo[]>([]); // Estado para almacenar los usos de suelo
  const [factores, setFactores] = useState<
    Record<
      string,
      {
        id: number;
        descripcion: string;
        limiteInferior: string;
        limiteSuperior: number;
        factor: string;
      }[]
    >
  >({});

  const [detalleAvaluo, setDetalleAvaluo] = useState<DetalleAvaluo>({
    areaTerreno: 0,
    idZona: 0,
    areaTerrenoCarto: 0,
    usoSuelo: '',
    medidaFrente: 0,
    medidaFondo: 0,
    ubicacion: '',
    tipoTopografia: '',
    desnivelPromedio: '',
    noEsquinas: 0,
    dcurbano: '',
    factorResultante: 1,
    zonaValor: '',
    valorM2: 0,
    esValorProvisional: false,

    distanciaU: 0,
    factorDistanciaU: 0,
    factorFrente: 0,
    factorProfundidad: 0,
    factorSuperficie: 0,
    factorTopografia: 0,
    factorUbicacion: 0,
  });
  //REDUX

  const user = useSelector((state: RootState) => state.auth.user);

//  alert(user.name)
  // TERMINA REDUX
  //const toast = useToast();
  const formatDateForInput = (dateString: string): string => {
    if (!dateString) return ''; // Si no hay fecha, devolver una cadena vacía
    const date = new Date(dateString);
    return date.toISOString().split('T')[0]; // Convertir a formato yyyy-MM-dd
  };

  // Cargar datos del avalúo desde la API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/avaluoRoutes/${id}`,
        );

        let data = response.data;
        if (data.id) {
          setBandera(true);
        }
        // Verificar si la data está vacía o nula
        if (!data || Object.keys(data).length === 0) {
          console.warn('La respuesta está vacía o no contiene datos.');
          return; // No hacer nada si los datos son vacíos
        }

        const formattedData = {
          ...data,
          fechaRegistro: formatDateForInput(data.fechaActualizacion), // Convertir fechaAvaluo a formato yyyy-MM-dd
          fechaVencimiento: formatDateForInput(data.fechaAvaluo),
        };

        setAvaluo(formattedData); // Actualizar el estado solo si hay datos válidos

        //alert(data.id);
        const responsex = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/detalleAvaluoRoutes/${data.id}`,
        );

        const responseData = responsex.data;

        // Verificar si la respuesta contiene datos válidos
        if (!responseData || responseData.length === 0) {
          console.warn(
            'La respuesta de detalleAvaluo está vacía o no contiene datos.',
          );
          return; // No hacer nada si los datos son vacíos
        }

        setDetalleAvaluo(responseData[0]);
      } catch {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la información del avalúo.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };

    const fetchZonas = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cZonaRoutes`,
        );
        setZonas(response.data);
      } catch {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la lista de zonas de valor.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };

    const fetchUsosSuelo = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cUsoDestinoRoutes`,
        );
        setUsosSuelo(response.data);
      } catch {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la lista de usos de suelo.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };

    const fetchNaturalezasActo = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cNaturalezaActoRoutes`,
        );
        setNaturalezasActo(
          response.data.filter((item: NaturalezaActo) => item.habilitado),
        );
      } catch {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la lista de naturalezas de acto.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };

    const fetchMotivosAvaluo = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cMotivoAvaluoRoutes`,
        );
        setMotivosAvaluo(
          response.data.filter((item: MotivoAvaluo) => item.habilitado),
        );
      } catch {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la lista de motivos de avalúo.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };

    const fetchFactores = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cFactorDemeritoRoutes`,
        );
        const data = response.data;

        // Agrupar factores por grupo
        const grouped = data.reduce((acc: Record<string, any[]>, item: any) => {
          if (!acc[item.grupo]) acc[item.grupo] = [];
          acc[item.grupo].push({
            id: item.id,
            descripcion: item.descripcion,
            limiteInferior: item.limiteInferior,
            limiteSuperior: item.limiteSuperior,
            factor: item.factor,
          });
          return acc;
        }, {});

        setFactores(grouped);
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la lista de factores.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    };

    fetchFactores();
    fetchMotivosAvaluo();

    fetchNaturalezasActo();

    fetchZonas();
    fetchUsosSuelo();

    fetchData();
  }, [id, toast,actualizacion]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setAvaluo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFactorChange = (value: string, field: keyof DetalleAvaluo) => {
    setDetalleAvaluo((prev) => ({
      ...prev,
      [field]: parseInt(value, 10),
    }));
  };

  const handleDetalleAvaluoChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setDetalleAvaluo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // const handleNumberChangeDetalleAvaluo = (value: string, name: string) => {
  //   setDetalleAvaluo((prev) => ({
  //     ...prev,
  //     [name]: parseFloat(value) || 0,
  //   }));
  // };
  const handleNumberChangeDetalleAvaluo = (
    valueString: string,
    name: string,
  ) => {
    // Validar y convertir a número solo si es válido
    const valueAsNumber = parseFloat(valueString);
    setDetalleAvaluo((prev) => ({
      ...prev,
      [name]: isNaN(valueAsNumber) ? valueString : valueAsNumber, // Permitir puntos finales
    }));
  };
  const handleNumberChange = (value: string, name: string) => {
    setAvaluo((prev) => ({
      ...prev,
      [name]: parseFloat(value) || 0,
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      if (bandera) {
        await axios.put(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/avaluoRoutes/${id}`,
          avaluo,
        );

        await axios.put(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/detalleAvaluoRoutes/${avaluo.id}`,
          detalleAvaluo,
        );

        setActualizacion((prev) => prev + 1);


        toast({
          title: 'Éxito',
          description: 'Avalúo actualizado correctamente.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      } else {
        const av = {
          ...avaluo,
          idClaveCatastral: id, // Incluye el valor de `id` directamente
        };
        const responseAvaluo = await axios.post(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/avaluoRoutes/`,
          av,
        );
      
         const avaluox = responseAvaluo.data;
        // await axios.post(
        //   `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/detalleAvaluoRoutes/${avaluox.id}`,
        //   detalleAvaluo,
        // );


        
        const avx = {
          ...detalleAvaluo,
          idAvaluo: avaluox.id, // Incluye el valor de `id` directamente
        };
        await axios.post(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/detalleAvaluoRoutes/`,
          avx,
        );

        setActualizacion((prev) => prev + 1);

        toast({
          title: 'Exito',
          description: 'Avaluo Creado.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar o crear el avalúo.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const totalValorCatastral = avaluo.valorTerreno + 0;
  const totalValorComercial = avaluo.valorComercial + 0;
  const handleZonaValorChange = async (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedZonaId = e.target.value;

    const selectedZona = zonas.find(
      (zona) => zona.id.toString() === selectedZonaId,
    );

    setDetalleAvaluo((prev) => ({
      ...prev,
      idZona: selectedZona ? parseInt(selectedZonaId) : 0, // Almacenar idZona como número
      zonaValor: selectedZona ? selectedZona.descripcion : '', // Almacenar la descripción
    }));

    if (selectedZonaId) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/cZonaValorRoutes/${selectedZonaId}`,
        );
        setDetalleAvaluo((prev) => ({
          ...prev,

          valorM2: response.data.valorM2, // Actualizar el valorM2 con la respuesta de la API
        }));
        //  setAvaluo((prev) => ({ ...prev, valorTerreno: nuevoValorTerreno }));
        //  const delta = e.movementX;
        //   const nuevoValorM2 = Math.max(0, detalleAvaluo.valorM2 + delta / 10);
        const nuevoValorTerreno =
          response.data.valorM2 * (detalleAvaluo.areaTerreno ?? 0); //* detalleAvaluo.areaTerreno;
        console.log(nuevoValorTerreno);
        setAvaluo((prev) => ({ ...prev, valorTerreno: nuevoValorTerreno }));
      } catch {
        toast({
          title: 'Error',
          description: 'No se pudo obtener el valor de la zona seleccionada.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    }
  };

  return (
    <Box p={[2, 4, 6]} maxW="1200px" mx="auto">
      <BloqueoPantalla isLoading={loading} />
      <form onSubmit={handleSubmit}>
        <Heading size="lg" mb={5} color="teal.500" paddingTop={5}>
          {' '}
          Terreno{' '}
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={4}>
          <FormControl>
            <FormLabel>Área Terreno (m²)</FormLabel>
            <NumberInput
              value={detalleAvaluo?.areaTerreno?.toString() ?? '0.0'}
              onChange={(valueString) => {
                handleNumberChangeDetalleAvaluo(valueString, 'areaTerreno');
                const area = parseFloat(valueString) || 0;
                const valorM2 = detalleAvaluo.valorM2 || 0; // Convertir a número y manejar valores no válidos
                const nuevoValorTerreno = valorM2 * area; // Calcular el nuevo valor del terreno
                setAvaluo((prev) => ({
                  ...prev,
                  valorTerreno: nuevoValorTerreno,
                }));
              }}
              precision={2} // Permite hasta 2 decimales
              step={0.1} // Incremento/decremento de 0.01
              clampValueOnBlur={false} // Evitar clamping automático al desenfocar
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Factor Frente</FormLabel>
            <NumberInput
              value={detalleAvaluo?.factorFrente ?? 0.0}
              onChange={(value) =>
                handleNumberChangeDetalleAvaluo(value, 'factorFrente')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Factor Profundidad</FormLabel>
            <NumberInput
              value={detalleAvaluo?.factorProfundidad ?? 0.0}
              onChange={(value) =>
                handleNumberChangeDetalleAvaluo(value, 'factorProfundidad')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Distancia U</FormLabel>
            <NumberInput
              value={detalleAvaluo?.distanciaU ?? 0.0}
              onChange={(value) =>
                handleNumberChangeDetalleAvaluo(value, 'distanciaU')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Factor Resultante</FormLabel>
            <NumberInput
              // value={detalleAvaluo.factorResultante}
              value={detalleAvaluo?.factorResultante ?? 0.0}
              onChange={(value) =>
                handleNumberChangeDetalleAvaluo(value, 'factorResultante')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>noEsquinas</FormLabel>
            <NumberInput
              value={detalleAvaluo?.noEsquinas ?? 0.0}
              onChange={(value) =>
                handleNumberChangeDetalleAvaluo(value, 'noEsquinas')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Factor Topografía</FormLabel>
            <Select
              name="factorTopografia"
              value={detalleAvaluo?.factorTopografia ?? ''}
              onChange={(e) =>
                handleFactorChange(e.target.value, 'factorTopografia')
              }
            >
              <option value="">Seleccione</option>
              {factores['TOPOGRAFIA']?.map((factor) => (
                <option key={factor.id} value={factor.id}>
                  {factor.descripcion}- {factor.limiteInferior} /
                  {factor.limiteSuperior} / {factor.factor}{' '}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Factor Ubicación</FormLabel>
            <Select
              name="factorUbicacion"
              value={detalleAvaluo?.factorUbicacion ?? ''}
              onChange={(e) =>
                handleFactorChange(e.target.value, 'factorUbicacion')
              }
            >
              <option value="">Seleccione</option>
              {factores['UBICACION']?.map((factor) => (
                <option key={factor.id} value={factor.id}>
                  {factor.descripcion}- {factor.limiteInferior} /
                  {factor.limiteSuperior} / {factor.factor}{' '}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Factor Superficie</FormLabel>
            <Select
              name="factorSuperficie"
              value={detalleAvaluo?.factorSuperficie ?? ''}
              onChange={(e) =>
                handleFactorChange(e.target.value, 'factorSuperficie')
              }
            >
              <option value="">Seleccione</option>
              {factores['SUPERFICIE']?.map((factor) => (
                <option key={factor.id} value={factor.id}>
                  {factor.descripcion}- {factor.limiteInferior} /
                  {factor.limiteSuperior} / {factor.factor}{' '}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Factor Distancia</FormLabel>
            <Select
              name="factorDistanciaU"
              value={detalleAvaluo?.factorDistanciaU ?? ''}
              onChange={(e) =>
                handleFactorChange(e.target.value, 'factorDistanciaU')
              }
            >
              <option value="">Seleccione</option>
              {factores['DISTANCIA']?.map((factor) => (
                <option key={factor.id} value={factor.id}>
                  {factor.descripcion}- {factor.limiteInferior} /
                  {factor.limiteSuperior} / {factor.factor}{' '}
                </option>
              ))}
            </Select>
          </FormControl>

          {/* <FormControl>
            <FormLabel>Uso de Suelo</FormLabel>
            <Select
              name="usoSuelo"
              value={detalleAvaluo.usoSuelo}
              onChange={handleDetalleAvaluoChange}
            >
              <option value="">Seleccione</option>
              {usosSuelo.map((uso) => (
                <option key={uso.id} value={uso.descripcion}>
                  {uso.descripcion}
                </option>
              ))}
            </Select>
          </FormControl> */}
        </SimpleGrid>

        <Heading size="sm" mt={6} mb={4} color="teal.500">
          Zonas
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
          <FormControl>
            <FormLabel>Zona de Valor</FormLabel>
            <Select
              name="idZona"
              value={detalleAvaluo?.idZona ?? ''}
              onChange={handleZonaValorChange} // Cambiar a la nueva función
            >
              <option value="">Seleccione</option>
              {zonas.map((zona) => (
                <option key={zona.id} value={zona.id}>
                  {zona.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Valor m²</FormLabel>

            <NumberInput
              value={`$${new Intl.NumberFormat('en-US', {}).format(
                detalleAvaluo.valorM2,
              )}`}
              onChange={(valueString) => {
                const valorM2 = parseFloat(valueString) || 0; // Convertir a número y manejar valores no válidos
                const nuevoValorTerreno =
                  valorM2 * (detalleAvaluo.areaTerreno ?? 0); // Calcular el nuevo valor del terreno

                // Actualizar detalleAvaluo y avaluo
                handleNumberChangeDetalleAvaluo(valueString, 'valorM2');
                setAvaluo((prev) => ({
                  ...prev,
                  valorTerreno: nuevoValorTerreno,
                }));
              }}
              precision={2} // Permitir hasta 2 decimales
              step={0.01} // Incremento/decremento de 0.01
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Valor Provisional</FormLabel>
            <Checkbox
              name="esValorProvisional"
              isChecked={detalleAvaluo.esValorProvisional}
              onChange={handleDetalleAvaluoChange}
            />
          </FormControl>
        </SimpleGrid>
        <Heading size="lg" mb={5} color="teal.500" paddingTop={5}>
          Generacion de Manifiesto y Avaluo
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={4}>
          <FormControl>
            <FormLabel>Fecha de Registro</FormLabel>
            <Input
              type="date"
              name="fechaRegistro"
              value={avaluo.fechaRegistro}
              onChange={(e) => {
                const fechaRegistro = e.target.value;
                const fecha = new Date(fechaRegistro);
                fecha.setFullYear(fecha.getFullYear() + 2); // Añadir 2 años
                const fechaVencimiento = fecha.toISOString().split('T')[0];

                setAvaluo((prev) => ({
                  ...prev,
                  fechaRegistro: fechaRegistro,
                  fechaVencimiento: fechaVencimiento, // Actualizar la fecha de vencimiento
                }));
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Fecha de Vencimiento</FormLabel>
            <Input
              type="date"
              name="fechaVencimiento"
              value={avaluo.fechaVencimiento}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Naturaleza del Acto</FormLabel>
            <Select
              name="idNaturalezaActo"
              value={avaluo.idNaturalezaActo}
              onChange={handleChange}
            >
              <option value="">Seleccione</option>
              {naturalezasActo.map((naturaleza) => (
                <option key={naturaleza.id} value={naturaleza.id}>
                  {naturaleza.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel>Motivo del Avalúo</FormLabel>
            <Select
              name="idMotivoAvaluo"
              value={avaluo.idMotivoAvaluo}
              onChange={handleChange}
            >
              <option value="">Seleccione</option>
              {motivosAvaluo.map((motivo) => (
                <option key={motivo.id} value={motivo.id}>
                  {motivo.descripcion}
                </option>
              ))}
            </Select>
          </FormControl>

          {/* <FormControl>
            <FormLabel>Caja Pago Predial</FormLabel>
            <Input
              name="cajaPagoPredial"
              value={avaluo.cajaPagoPredial}
              onChange={handleChange}
            />
        
          </FormControl> */}

          <FormControl>
            <FormLabel>Folio de Pago Predial</FormLabel>
            <NumberInput
              value={avaluo.folioPagoPredial}
              onChange={(value) =>
                handleNumberChange(value, 'folioPagoPredial')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          {/* <FormControl>
            <FormLabel>Caja Pago Avalúo</FormLabel>
            <Input
              name="cajaPagoAvaluo"
              value={avaluo.cajaPagoAvaluo}
              onChange={handleChange}
            />
          </FormControl> */}

          <FormControl>
            <FormLabel>Folio de Pago Avalúo</FormLabel>
            <NumberInput
              value={avaluo.folioPagoAvaluo}
              onChange={(value) => handleNumberChange(value, 'folioPagoAvaluo')}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Observaciones</FormLabel>
            <Textarea
              name="obsAvaluo"
              value={avaluo.obsAvaluo}
              onChange={handleChange}
            />
          </FormControl>
        </SimpleGrid>

        <Heading size="sm" mt={6} mb={4} color="teal.500">
          Valores Catastrales:
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4}} spacing={4}>
          <FormControl>
            <FormLabel>Terreno</FormLabel>
            <NumberInput
              value={avaluo.valorTerreno || 0} // Formatea con separadores de miles y decimales
              onChange={(valueString) => {
                const rawValue =
                  parseFloat(
                    valueString.replace(/,/g, ''), // Remueve comas como separadores de miles
                  ) || 0;

                handleNumberChange(rawValue.toString(), 'valorTerreno'); // Actualiza el estado con el valor crudo
              }}
              precision={2}
              step={0.1}
            >
              <NumberInputField placeholder="Ingrese el valor del terreno" />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Construcción</FormLabel>
            <NumberInput
              value={avaluo.valorCatastralConstruccion}
              onChange={(value) =>
                handleNumberChange(value, 'valorCatastralConstruccion')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Total</FormLabel>
            <Input
              value={`$${new Intl.NumberFormat('en-US', {}).format(
                totalValorCatastral,
              )}`}
              isDisabled
            />
          </FormControl>

          <Button
            bg="#bb8c52"
            color="white"
            _hover={{ bg: "#a67c47" }}
            onClick={async () => {
              const toastId = toast({
                title: 'Generando archivo...',
                description: 'Por favor espera mientras generamos el Avaluo.',
                status: 'info',
                duration: null, // Mantener hasta que se cierre manualmente
                isClosable: true,
              });
              try {
                const response = await axios.get(
                  //  `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReporteAvaluo/${id}`,
                  `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReporteAvaluo/${id}/${user.id}`,

                  {
                    responseType: 'blob',
                  },
                );

                const url = window.URL.createObjectURL(
                  new Blob([response.data], { type: 'application/pdf' }),
                );

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Avaluo_${id}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                toast.close(toastId);
                toast({
                  title: 'Éxito',
                  description: 'El Avaluo se generó y descargó correctamente.',
                  status: 'success',
                  duration: 5000,
                  isClosable: true,
                });
                // alert('El manifiesto se generó y descargó correctamente.');
              } catch (error) {
                console.error('Error al generar el manifiesto:', error);
                alert('No se pudo generar el manifiesto. Inténtalo de nuevo.');
              }
            }}
          >
            Generar Avaluo
          </Button>
        </SimpleGrid>

        <Heading size="sm" mt={6} mb={4} color="teal.500">
          Valores Comerciales:
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
          <FormControl>
            <FormLabel>Terreno</FormLabel>
            <NumberInput
              value={avaluo.valorComercial}
              onChange={(value) => handleNumberChange(value, 'valorComercial')}
              precision={2}
              step={0.1}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Construcción</FormLabel>
            <NumberInput
              value={avaluo.valorComercialConstruccion}
              onChange={(value) =>
                handleNumberChange(value, 'valorComercialConstruccion')
              }
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>

          <FormControl>
            <FormLabel>Total</FormLabel>
            <Input
              value={`$${new Intl.NumberFormat('en-US', {}).format(
                totalValorComercial,
              )}`}
              isDisabled // Si el campo no es editable
            />
          </FormControl>
          <Button
            bg="#bb8c52"
            color="white"
            _hover={{ bg: "#a67c47" }}
            onClick={async () => {
              // Mostrar el toast de carga
              setLoading(true);

              const toastId = toast({
                title: 'Generando archivo...',
                description:
                  'Por favor espera mientras generamos el manifiesto.',
                status: 'info',
                duration: null, // Mantener hasta que se cierre manualmente
                isClosable: true,
              });

              try {
                const response = await axios.get(
                  `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/ReporteManifiesto/${id}/${user.id}`,
                  {
                    responseType: 'blob',
                  },
                );

                const url = window.URL.createObjectURL(
                  new Blob([response.data], { type: 'application/pdf' }),
                );

                // const link = document.createElement('a');
                // link.href = url;
                // link.setAttribute('download', `Manifiesto_${id}.pdf`);
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);

                // Abrir el archivo en una nueva pestaña
                window.open(url, '_blank');

                // Cerrar el toast de carga y mostrar el de éxito
                toast.close(toastId);
                toast({
                  title: 'Éxito',
                  description:
                    'El manifiesto se generó y descargó correctamente.',
                  status: 'success',
                  duration: 5000,
                  isClosable: true,
                });
              } catch (error) {
                console.error('Error al generar el manifiesto:', error);

                // Cerrar el toast de carga y mostrar el de error
                toast.close(toastId);
                toast({
                  title: 'Error',
                  description:
                    'No se pudo generar el manifiesto. Inténtalo de nuevo.',
                  status: 'error',
                  duration: 5000,
                  isClosable: true,
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            Generar Manifestación
          </Button>
        </SimpleGrid>
        <Button type="submit" bg="#5b182b" color="white" _hover={{ bg: "#691f30" }} mt={4} width="auto">
          {bandera ? 'Actualizar Avaluo y Manifestacion' : 'Crear Avaluo'}
        </Button>
      </form>

      {bandera && (
        <HistoricoAvaluo idClaveCatastral={Number(id)}></HistoricoAvaluo>
      )}
    </Box>
  );
};

export default AvaluoForm;
